// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2XzXe","paramInput":"JobSimulator_paramInput__1S5m8","input":"JobSimulator_input__1ZWQ2"};